export const version = [
    {
        version: 'V0.6.5.9',
        date: '05 Apr 2024',
        updateList: [
            { desc: 'Master Data Container Van: Additional Status' },
        ],
    },
    {
        version: 'V0.6.5.8',
        date: '26 Mar 2024',
        updateList: [
            { desc: 'Cargo Release Order Changes' },
        ],
    },
    {
        version: 'V0.6.5.7',
        date: '06 Mar 2024',
        updateList: [
            { desc: 'SQ Amend Date Effective Validation' },
        ],
    },
    {
        version: 'V0.6.5.6',
        date: '04 Mar 2024',
        updateList: [
            { desc: 'Waybill: Split Charge Fixes' },
        ],
    },
    {
        version: 'V0.6.5.5',
        date: '17 Jan 2024',
        updateList: [
            { desc: 'Booking Changes: Allow Bypass Internal Amend Fee' },
        ],
    },
    {
        version: 'V0.6.5.4',
        date: '16 Jan 2024',
        updateList: [
            { desc: 'Booking Changes: remove disabled charge to on AMF' },
        ],
    },
    {
        version: 'V0.6.5.3',
        date: '13 Dec 2023',
        updateList: [
            { desc: 'Sales Quotation: only show Request Column if Requested' },
        ],
    },
    {
        version: 'V0.6.5.2',
        date: '11 Dec 2023',
        updateList: [
            { desc: 'Collection List: Balance Amount Fixes' },
        ],
    },
    {
        version: 'V0.6.5.1',
        date: '05 Dec 2023',
        updateList: [
            { desc: 'Collection List: Balance Amount Fixes' },
        ],
    },
    {
        version: 'V0.6.5.0',
        date: '15 Nov 2023',
        updateList: [
            { desc: 'Booking Changes: Newly Added Charge Include on Revise Change from Waybill' },
        ],
    },
    {
        version: 'V0.6.4.9',
        date: '21 Oct 2023',
        updateList: [
            { desc: 'CRO Accounting Posting Generate Invoice Reload Data Reset' },
        ],
    },
    {
        version: 'V0.6.4.8',
        date: '19 Oct 2023',
        updateList: [
            { desc: 'Web Update' },
        ],
    },
    {
        version: 'V0.6.4.7',
        date: '18 Oct 2023',
        updateList: [
            { desc: 'Page Fix' },
        ],
    },
    {
        version: 'V0.6.4.6',
        date: '17 Oct 2023',
        updateList: [
            { desc: 'Roles: System Account User - Allow Change Password Added' },
            { desc: 'User: Change Password Added' },
            { desc: 'Landing Page Changes' },
        ],
    },
    {
        version: 'V0.6.4.5',
        date: '09 Aug 2023',
        updateList: [
            { desc: 'Loading & Unloading Tallysheet Printout - Show Finalize Remarks' },
        ],
    },
    {
        version: 'V0.6.4.4',
        date: '31 Jul 2023',
        updateList: [
            { desc: 'Inbound CRO Create - Has Over Ride Condition' },
            { desc: 'Outbound Tallysheet Show Cargo Type' },
        ],
    },
    {
        version: 'V0.6.4.3',
        date: '08 Jun 2023',
        updateList: [
            { desc: 'CRO Accounting - Manual SI - Show Base Base Waybill Number on Raw Material Commodity' },
            { desc: 'CRO Accounting - Manual SI - Show Base Base Waybill Number on Finished Goods Commodity' },
        ],
    },
    {
        version: 'V0.6.4.2',
        date: '05 Jun 2023',
        updateList: [
            { desc: 'Waybill Remove Charge Exemption Checking' },
            { desc: 'Waybill Creation Change Booking Search Fixes' },
        ],
    },
    {
        version: 'V0.6.4.1',
        date: '02 Jun 2023',
        updateList: [
            { desc: 'Booking Rates Applied Fixes' },
        ],
    },
    {
        version: 'V0.6.4.0',
        date: '20 May 2023',
        updateList: [
            { desc: 'SQ Approval Change Setup' },
            { desc: 'Master Data - Freight Rates - FCL - FA Standard Freight Added' },
        ],
    },
    {
        version: 'V0.6.3.9',
        date: '15 May 2023',
        updateList: [
            { desc: 'SQ Special Approval rollback setup' },
        ],
    },
    {
        version: 'V0.6.3.8',
        date: '11 May 2023',
        updateList: [
            { desc: 'SQ Printout RC BB Fixes' },
            { desc: 'SQ Special Approval UI Bypass SM to FA' },
        ],
    },
    {
        version: 'V0.6.3.7',
        date: '02 May 2023',
        updateList: [
            { desc: 'SQ Memorandum Select SQ Fixes' },
            { desc: 'User Exclude SQ Notification' },
        ],
    },
    {
        version: 'V0.6.3.6',
        date: '01 Mar 2023',
        updateList: [
            { desc: 'SQ Printout Changes' },
        ],
    },
    {
        version: 'V0.6.3.5',
        date: '18 Feb 2023',
        updateList: [
            { desc: 'Inbound CTS & CDR - Non FCL Cargo Setup' },
        ],
    },
    {
        version: 'V0.6.3.4',
        date: '14 Feb 2023',
        updateList: [
            { desc: 'SQ Printout Changes' },
        ],
    },
    {
        version: 'V0.6.3.3',
        date: '11 Feb 2023',
        updateList: [
            { desc: 'SQ Memorandum Select SQ Fixes' },
        ],
    },
    {
        version: 'V0.6.3.2',
        date: '10 Feb 2023',
        updateList: [
            { desc: 'SQ Print-out AE Signature Fixes' },
            { desc: 'Waybill Form Fixes' },
        ],
    },
    {
        version: 'V0.6.3.1',
        date: '08 Feb 2023',
        updateList: [
            { desc: 'Booking Changes Open Van Charge Fixes' },
        ],
    },
    {
        version: 'V0.6.3.0',
        date: '06 Feb 2023',
        updateList: [
            { desc: 'Booking Changes Read Charge Fixes' },
            { desc: 'Cargo Costing Manifest Van-out Fixes' },
        ],
    },
    {
        version: 'V0.6.2.9',
        date: '16 Jan 2023',
        updateList: [
            { desc: 'Create Collection Changes' },
        ],
    },
    {
        version: 'V0.6.2.8',
        date: '07 Jan 2023',
        updateList: [
            { desc: 'SQ Printout Fixes' },
        ],
    },
    {
        version: 'V0.6.2.7',
        date: '03 Jan 2023',
        updateList: [
            { desc: 'SQ Approved Viewer View Fixes' },
            { desc: 'SQ PDF Viewer Loading' },
            { desc: 'Transaction Trucking Charge Setup Changes' },
        ],
    },
    {
        version: 'V0.6.2.6',
        date: '19 Dec 2022',
        updateList: [
            { desc: 'Simple Overview Page Setup' },
            { desc: 'SQ For Approval Read View Fixes' },
        ],
    },
    {
        version: 'V0.6.2.5',
        date: '16 Dec 2022',
        updateList: [
            { desc: 'SQ Approver - Read Printout Fixes' },
            { desc: 'Outbound Reguide Fixes' },
        ],
    },
    {
        version: 'V0.6.2.4',
        date: '15 Dec 2022',
        updateList: [
            { desc: 'Actual Voyage Report - Data Fixes' },
            { desc: 'SQ Printout Signatory Fixes' },
            { desc: 'Temporary Remove Logout Timer - Cause Lag Rendering' },
            { desc: 'Allow Leave Page Path Fixes' },
        ],
    },
    {
        version: 'V0.6.2.3',
        date: '13 Dec 2022',
        updateList: [
            { desc: 'User Update Fixes' },
        ],
    },
    {
        version: 'V0.6.2.2',
        date: '12 Dec 2022',
        updateList: [
            { desc: 'User Save Fixes' },
        ],
    },
    {
        version: 'V0.6.2.1',
        date: '02 Dec 2022',
        updateList: [
            { desc: 'SQ Terms and Conditions Changes' },
            { desc: 'SQ Archive List Fixes' },
            { desc: 'Role Load Fixes' },
        ],
    },
    {
        version: 'V0.6.2.0',
        date: '17 Nov 2022',
        updateList: [
            { desc: 'Override Read Changes' },
            { desc: 'Override List Changes' },
        ],
    },
    {
        version: 'V0.6.1.9',
        date: '16 Nov 2022',
        updateList: [
            { desc: 'List Duplicate Fixes' },
            { desc: 'Customer Request Creation Fixes' },
            { desc: 'Inbound Tallysheet - Empty Fixes' },
        ],
    },
    {
        version: 'V0.6.1.8',
        date: '12 Nov 2022',
        updateList: [
            { desc: 'Inbound List Duplicate Fixes' },
        ],
    },
    {
        version: 'V0.6.1.7',
        date: '08 Nov 2022',
        updateList: [
            { desc: 'Booking Read Rollback' },
        ],
    },
    {
        version: 'V0.6.1.6',
        date: '07 Nov 2022',
        updateList: [
            { desc: 'Waiver - additional detail' },
        ],
    },
    {
        version: 'V0.6.1.5',
        date: '05 Oct 2022',
        updateList: [
            { desc: 'Rollback Waybill - "XXXXXX" charge amount condition' },
        ],
    },
    {
        version: 'V0.6.1.4',
        date: '04 Oct 2022',
        updateList: [
            { desc: 'Waybill - Remove "XXXXXX" charge amount condition' },
            { desc: 'Waybill - Printout Changes' },
        ],
    },
    {
        version: 'V0.6.1.3B',
        date: '29 Sep 2022',
        updateList: [
            { desc: 'Booking Changes For Approval List - Admin Endorser Approval Button ' },
        ],
    },
    {
        version: 'V0.6.1.3',
        date: '29 Sep 2022',
        updateList: [
            { desc: 'Booking Changes List Fixes' },
        ],
    },
    {
        version: 'V0.6.1.2',
        date: '23 Sep 2022',
        updateList: [
            { desc: 'Booking Changes Waybill Charges Checking Fixes' },
        ],
    },
    {
        version: 'V0.6.1.1',
        date: '13 Sep 2022',
        updateList: [
            { desc: 'Schedule List Fixes' },
        ],
    },
    {
        version: 'V0.6.1.0',
        date: '12 Sep 2022',
        updateList: [
            { desc: 'Waiver Read Additional Detail' },
            { desc: 'Van History Changes' },
        ],
    },
    {
        version: 'V0.6.0.9B',
        date: '24 Aug 2022',
        updateList: [
            { desc: 'SQ Approver - FA Button Remove Checking' },
        ],
    },
    {
        version: 'V0.6.0.9',
        date: '24 Aug 2022',
        updateList: [
            { desc: 'SQ Approver - FA Remove Checking' },
        ],
    },
    {
        version: 'V0.6.0.8',
        date: '19 Aug 2022',
        updateList: [
            { desc: 'Booking - New Charge Filtering' },
            { desc: 'Outbound Waybill - New Charge Filtering' },
            { desc: 'Booking Changes - New Charge Filtering' },
        ],
    },
    {
        version: 'V0.6.0.7',
        date: '18 Aug 2022',
        updateList: [
            { desc: 'Outbound CTS - Tandem Search Checking' },
            { desc: 'Outbound Waybill - Tandem Search Checking' },
            { desc: 'Inbound CTS - Tandem Search Checking' },
            { desc: 'Revenue Analysis Report - Comparative' },
            { desc: 'Voyage Report - Add Show/Hide Entry' },
            { desc: 'Inbound Dwell Time Report - Add Show/Hide Entry' },
            { desc: 'SQ Report - Add Show/Hide Entry' },
        ],
    },
    {
        version: 'V0.6.0.6B',
        date: '15 Aug 2022',
        updateList: [
            { desc: 'Waiver List - Select All Fixes' },
        ]
    },
    {
        version: 'V0.6.0.6',
        date: '15 Aug 2022',
        updateList: [
            { desc: 'SQ Printout Fixes' },
            { desc: 'Waiver For Approval Fixes' },
        ]
    },
    {
        version: 'V0.6.0.5',
        date: '13 Aug 2022',
        updateList: [
            { desc: 'SQ Approved View LCT' },
        ]
    },
    {
        version: 'V0.6.0.4',
        date: '11 Aug 2022',
        updateList: [
            { desc: 'Booking Creation - Load Batch Fixes' },
        ]
    },
    {
        version: 'V0.6.0.3',
        date: '09 Aug 2022',
        updateList: [
            { desc: 'Booking Changes For Approval List - Management Approver Checking Fixes' },
        ]
    },
    {
        version: 'V0.6.0.2B',
        date: '05 Aug 2022',
        updateList: [
            { desc: 'Voyage Freight Revenue Report' },
            { desc: 'Voyage Freight Revenue Report Roles Added' },
            { desc: 'Outbound CTS List - Booking Ref Link = Booking View' },
            { desc: 'Waybill List - Booking Ref Link = Booking View' },
            { desc: 'Vessel Arrival Notice List - Booking Ref Link = Booking View' },
            { desc: 'Cargo Release Order List - Booking Ref Link = Booking View' },
            { desc: 'Inbound CTS List - Booking Ref Link = Booking View' },
            { desc: 'Waiver - Approver Fixes' },
            { desc: 'Waiver Creation - Remarks Require' },
            { desc: 'Booking Changes Creation - Not Allowed Booking Status Draft and Confirmed' },
        ]
    },
    {
        version: 'V0.6.0.2',
        date: '05 Aug 2022',
        updateList: [
            { desc: 'Waybill - Remove Posted Restriction' },
            { desc: 'Booking Changes - Endorser Fixes' },
        ]
    },
    {
        version: 'V0.6.0.1',
        date: '04 Aug 2022',
        updateList: [
            { desc: 'Inbound CTS and CDR Printout Fixes' },
            { desc: 'PDC List Fixes' },
        ]
    },
    {
        version: 'V0.6.0.0',
        date: '02 Aug 2022',
        updateList: [
            { desc: 'Waybill - Shipper/Consignee SI Field Fixes' },
            { desc: 'Waiver Additional Data' },
        ]
    },
    {
        version: 'V0.6.0.0X',
        date: '02 Aug 2022',
        updateList: [
            { desc: 'Waybill - Shipper/Consignee SI Field Fixes' },
            { desc: 'Waiver Additional Data' },
        ]
    },
    {
        version: 'V0.5.9.9B',
        date: '01 Aug 2022',
        updateList: [
            { desc: 'Waybill - Shipper/Consignee SI Field Selection and Posted Condition Checking' },
        ]
    },
    {
        version: 'V0.5.9.9',
        date: '01 Aug 2022',
        updateList: [
            { desc: 'Booking - Charge MD Duplicate Checking' },
            { desc: 'Booking Changes - Charge MD Duplicate Checking' },
            { desc: 'Booking Changes - Download Approved BC Fixes' },
        ]
    },
    {
        version: 'V0.5.9.9X',
        date: '30 Jul 2022',
        updateList: [
            { desc: 'Waybill - Split Checking For SI' },
        ]
    },
    {
        version: 'V0.5.9.8X',
        date: '29 Jul 2022',
        updateList: [
            { desc: 'Booking - Van-Out Condition Fixes' },
            { desc: 'Booking Changes - Van-Out Condition Fixes' },
            { desc: 'SQ Printout Standard/Request Charge Fixes' },
        ]
    },
    {
        version: 'V0.5.9.8',
        date: '29 Jul 2022',
        updateList: [
            { desc: 'Waybill - Shipper/Consignee SI Field Selection and Posted Condition Checking' },
        ]
    },
    {
        version: 'V0.5.9.7',
        date: '28 Jul 2022',
        updateList: [
            { desc: 'Booking Cargo Type not FCL, hide Van-Out Selection' },
            { desc: 'Booking Changes Cargo Type not FCL, hide Van-Out Selection' },
        ]
    },
    {
        version: 'V0.5.9.6',
        date: '27 Jul 2022',
        updateList: [
            { desc: 'Waybill - Enable Trucking Charge' },
        ]
    },
    {
        version: 'V0.5.9.5',
        date: '25 Jul 2022',
        updateList: [
            { desc: 'Booking - Tandem Error Message Change to Warning' },
            { desc: 'Booking Changes - Tandem Error Message Change to Warning' },
        ]
    },
    {
        version: 'V0.5.9.4',
        date: '23 Jul 2022',
        updateList: [
            { desc: 'SQ Expire and Unexpire Button Swap' },
            { desc: 'SQ Approved View - Access Restiction URL for See Details' },
        ]
    },
    {
        version: 'V0.5.9.3',
        date: '22 Jul 2022',
        updateList: [
            { desc: 'SQ List Fixes' },
        ]
    },
    {
        version: 'V0.5.9.2',
        date: '21 Jul 2022',
        updateList: [
            { desc: 'Booking Changes - Internal Request - Allow Attach File' },
            { desc: 'Waiver For Endorser Fixes' },
            { desc: 'SQ Unexpire and Expire' },
        ]
    },
    {
        version: 'V0.5.9.1',
        date: '20 Jul 2022',
        updateList: [
            { desc: 'SQ Printout Fixes' },
        ]
    },
    {
        version: 'V0.5.9.0',
        date: '19 Jul 2022',
        updateList: [
            { desc: 'Schedule and Booking Voyage Vessel Status Color Changes' },
            { desc: 'SQ Printout Is Expired' },
            { desc: 'Waiver For Endorser Fixes' },
        ]
    },
    {
        version: 'V0.5.8.9',
        date: '18 Jul 2022',
        updateList: [
            { desc: 'Van-In Inbound Demurage Checking' },
            { desc: 'Booking Voyage Vessel Status' },
            { desc: 'Inbound Dwell Time Report - CY Grounded' },
            { desc: 'Waiver List Starts with Created Date Desc' },
            { desc: 'Oubound CTS and CBS - shipper signature remove name to Signature Over Printed Name and Changes' },
            { desc: 'Help and Support - Browser Notification' },
            { desc: 'Booking Create Remarks Fixes' },
            { desc: 'Image Select Dialog Changes' },
        ]
    },
    {
        version: 'V0.5.8.8',
        date: '16 Jul 2022',
        updateList: [
            { desc: 'Booking Volume & CSR Report Fixes' },
        ]
    },
    {
        version: 'V0.5.8.7',
        date: '15 Jul 2022',
        updateList: [
            { desc: 'Inbound CTS & CDR Creation Checking User Branch' },
            { desc: 'Booking Volume & CSR Report Route Type Added on Volumn with CSR' },
            { desc: 'Booking Changes Read/View Page - Image Expand and Download' },
            { desc: 'Waiver Read/View Page - Image Expand and Download' },
            { desc: 'Customer Request Read/View Page - Image Expand' },
        ]
    },
    {
        version: 'V0.5.8.6',
        date: '12 Jul 2022',
        updateList: [
            { desc: 'Booking Changes and Waiver - Endorser (Admin) Roles Added' },
            { desc: 'Booking Changes List Changes' },
            { desc: 'Waiver List Changes' },
        ]
    },
    {
        version: 'V0.5.8.5',
        date: '11 Jul 2022',
        updateList: [
            { desc: 'Inbound CRO Creation - Other Charge Checking' },
        ]
    },
    {
        version: 'V0.5.8.4',
        date: '08 Jul 2022',
        updateList: [
            { desc: 'Booking Changes Loading Charges Fixes' },
            { desc: 'Booking Loading Charges Fixes' },
            { desc: 'SQ Printout Fixes' },
        ]
    },
    {
        version: 'V0.5.8.3',
        date: '07 Jul 2022',
        updateList: [
            { desc: 'Booking Changes - Status Text Fixes' },
            { desc: 'Dark Mode' },
        ]
    },
    {
        version: 'V0.5.8.2',
        date: '05 Jul 2022',
        updateList: [
            { desc: 'Inbound CTS and CDR Printout Fixes on Tandem' },
        ]
    },
    {
        version: 'V0.5.8.1C',
        date: '04 Jul 2022',
        updateList: [
            { desc: 'Booking Changes Amend Fee Fixes' },
            { desc: 'Booking Changes Read Fixes' },
        ]
    },
    {
        version: 'V0.5.8.1B',
        date: '04 Jul 2022',
        updateList: [
            { desc: 'Booking Changes Creation Fixes' },
        ]
    },
    {
        version: 'V0.5.8.1',
        date: '04 Jul 2022',
        updateList: [
            { desc: 'Booking Changes Creation Fixes' },
        ]
    },
    {
        version: 'V0.5.8.0',
        date: '02 Jul 2022',
        updateList: [
            { desc: 'Cargo Costing Manifest - Remarks on Tandem' },
            { desc: 'Booking Changes - Accounting Approver Fixes' },
            { desc: 'Booking Changes - Detect Amend Fee' },
            { desc: 'Booking Changes - No Amend Fee on Booking Status: Confirmed, ATW Issued, and Outbound CTS Issued' },
            { desc: 'Dark Mode (Beta)' },
        ]
    },
    {
        version: 'V0.5.7.9',
        date: '28 Jun 2022',
        updateList: [
            { desc: 'Redirecting Page Fixes' },
        ]
    },
    {
        version: 'V0.5.7.8',
        date: '27 Jun 2022',
        updateList: [
            { desc: 'SQ Printout T&C Highlight Fixes' },
            { desc: 'Booking Creation: if RC and BB, remove charge checking for Stuffing, Stripping, and Van-Out' },
            { desc: 'Booking Changes Creation: if RC and BB, remove charge checking for Stuffing, Stripping, and Van-Out' },
        ]
    },
    {
        version: 'V0.5.7.7',
        date: '25 Jun 2022',
        updateList: [
            { desc: 'react-router to react-router-dom' },
        ]
    },
    {
        version: 'V0.5.7.6',
        date: '24 Jun 2022',
        updateList: [
            { desc: 'SQ Report - SQ Per Customer Without Booking Routes Added' },
            { desc: 'SQ Updated List - Charges Added' },
        ]
    },
    {
        version: 'V0.5.7.5B',
        date: '23 Jun 2022',
        updateList: [
            { desc: 'Prompt Error Message' },
            { desc: 'Booking Changes List, Read, Approved Download - Booking Status' },
            { desc: 'Booking Change List - Approval Status' },
            { desc: 'Waiver List - Approval Status' },
            { desc: 'Disable Button when Saving' },
            { desc: 'Not Closing Dialog when Saving' },
        ]
    },
    {
        version: 'V0.5.7.5',
        date: '23 Jun 2022',
        updateList: [
            { desc: 'Prevent Changing Page Upon Saving/Loading  Datas' },
            { desc: 'Waiver Is Endorser' },
            { desc: 'Booking Changes Is Endorser' },
            { desc: 'Cargo Loading Report - Booking Date and CTS Date' },
        ]
    },
    {
        version: 'V0.5.7.4',
        date: '20 Jun 2022',
        updateList: [
            { desc: 'Booking - Check Charge Fixes' },
            { desc: 'Booking Change - Check Charge Fixes' },
            { desc: 'Waybill Charge Exemption Fixes' },
            { desc: 'Waybill - Enable Amendment Fee Charge To' },
        ]
    },
    {
        version: 'V0.5.7.3',
        date: '17 Jun 2022',
        updateList: [
            { desc: 'Booking - Mode of Delivery Changes Stuffing, Stripping, Van-Out Fixes' },
            { desc: 'Booking Change - Mode of Delivery Changes Stuffing, Stripping, Van-Out Fixes' },
            { desc: 'Booking Change Report Fixes' },
        ]
    },
    {
        version: 'V0.5.7.2',
        date: '15 Jun 2022',
        updateList: [
            { desc: 'Booking Change Approved Download Changes' },
            { desc: 'Booking Change - always show Amend Type' },
            { desc: 'Booking Change - For Accounting Approve Page' },
            { desc: 'Role - For Accounting Approve Added' },
        ]
    },
    {
        version: 'V0.5.7.1',
        date: '13 Jun 2022',
        updateList: [
            { desc: 'Booking Change Approved Download' },
            { desc: 'Inbound Dwell Time Report - Empty Van' },
        ]
    },
    {
        version: 'V0.5.7.0',
        date: '10 Jun 2022',
        updateList: [
            { desc: 'Manual SI - Report Type EMPTY BOTTLES added' },
        ]
    },
    {
        version: 'V0.5.6.9',
        date: '09 Jun 2022',
        updateList: [
            { desc: 'Role Waiver - Allow Endorser and Approver at the same time' },
            { desc: 'Manual SI - Total Amount Placement' },
        ]
    },
    {
        version: 'V0.5.6.8',
        date: '08 Jun 2022',
        updateList: [
            { desc: 'Booking Changes - Change Amend Fee Setup' },
            { desc: 'Manual SI - Header Wrap Text' },
        ]
    },
    {
        version: 'V0.5.6.7',
        date: '02 Jun 2022',
        updateList: [
            { desc: 'Booking Changes - Trucking Charges Fixes' },
        ]
    },
    {
        version: 'V0.5.6.6',
        date: '01 Jun 2022',
        updateList: [
            { desc: 'Cargo Costing Manifest - Add CTS Data Column' },
            { desc: 'Booking Changes - Van-out Amend Fee Fixes' },
            { desc: 'Booking Changes List Submitted By Change (TimeAgo to ActualDateTime)' },
            { desc: 'Outbound Waybill List Created By, Modified By Change (TimeAgo to ActualDateTime)' },
        ]
    },
    {
        version: 'V0.5.6.5',
        date: '31 May 2022',
        updateList: [
            { desc: 'Master Freight Rates Data Read Data Checking Fixes' },
            { desc: 'Master Port Rates Data Read Data Checking Fixes' },
            { desc: 'Master Trucking Rates Data Read Data Checking Fixes' },
        ]
    },
    {
        version: 'V0.5.6.4',
        date: '28 May 2022',
        updateList: [
            { desc: 'Booking Door Rate Checking' },
            { desc: 'Booking Changes Door Rate Checking' },
            { desc: 'Booking Changes For Endorse List Button Fixes' },
        ]
    },
    {
        version: 'V0.5.6.3',
        date: '27 May 2022',
        updateList: [
            { desc: 'Booking Changes Accounting Approved Roles Added' },
            { desc: 'Booking Changes Accounting Approved Page Added' },
            { desc: 'SQ Approved Viewer Customer SQ List Sorting Fixes' },
            { desc: 'Booking Changes - Amend Fee Conditions Fixes' },
        ]
    },
    {
        version: 'V0.5.6.2B',
        date: '24 May 2022',
        updateList: [
            { desc: 'Manual SI - Printout Layout 14 Inches Legal Size' },
        ]
    },
    {
        version: 'V0.5.6.2',
        date: '24 May 2022',
        updateList: [
            { desc: 'Manual SI - Printout Changes' },
        ]
    },
    {
        version: 'V0.5.6.1',
        date: '23 May 2022',
        updateList: [
            { desc: 'Manual SI - CONTAINERIZED enable ang Total Amount' },
            { desc: 'Approved Viewer - Customer SQ List Expire Sorting' },
            { desc: 'Approved Viewer - Customer SQ List change Expire color' },
            { desc: 'Booking Changes For Approval List - Cancel Added' },
            { desc: 'Booking Changes - Change Booking Date Fixes' },
        ]
    },
    {
        version: 'V0.5.6.0',
        date: '18 May 2022',
        updateList: [
            { desc: 'SQ Approved Viewer Customer All SQ Download' },
        ]
    },
    {
        version: 'V0.5.5.9',
        date: '17 May 2022',
        updateList: [
            { desc: 'SQ Printout Fixes - Area Province Added' },
            { desc: 'SQ Area Province Show' },
            { desc: 'SQ Documents - Prevent from added same Area Province' },
        ]
    },
    {
        version: 'V0.5.5.8',
        date: '14 May 2022',
        updateList: [
            { desc: 'Manual SI Changes' },
        ]
    },
    {
        version: 'V0.5.5.7',
        date: '13 May 2022',
        updateList: [
            { desc: 'Booking Changes - Amend Fee Invoice Fixes' },
        ]
    },
    {
        version: 'V0.5.5.6',
        date: '12 May 2022',
        updateList: [
            { desc: 'Booking Changes - Waybill Posted Invoice Fixes' },
        ]
    },
    {
        version: 'V0.5.5.5',
        date: '11 May 2022',
        updateList: [
            { desc: 'Outbound Waybill 2nd Tandem Load Fixes' },
            { desc: 'Manual SI Print Feature Added' },
        ]
    },
    {
        version: 'V0.5.5.4',
        date: '07 May 2022',
        updateList: [
            { desc: 'CRO Accounting Posting - Date SI Posted Fixes' },
        ]
    },
    {
        version: 'V0.5.5.3B',
        date: '02 May 2022',
        updateList: [
            { desc: 'Outbound Waybill - Charge Exemption Fixes' },
        ]
    },
    {
        version: 'V0.5.5.3',
        date: '02 May 2022',
        updateList: [
            { desc: 'Booking Changes - Ammend Fee for Van-Out' },
            { desc: 'Master Data Customer Load Read Fixes' },
        ]
    },
    {
        version: 'V0.5.5.2',
        date: '30 Apr 2022',
        updateList: [
            { desc: 'Waiver Denied/Cancelled - remove Move to Draft restriction' },
            { desc: 'Booking Changes - Change Status Text' },
            { desc: 'Booking Changes - change shipper or consignee require revise mode of payment' },
            { desc: 'Manual SI - Added Billing Statement Number Field' },
            { desc: 'Manual SI Edit - Load Other Waybill' },
        ]
    },
    {
        version: 'V0.5.5.1',
        date: '27 Apr 2022',
        updateList: [
            { desc: 'Manual SI - OCEAN TRANSPORT Shipping Line Default' },
            { desc: 'Booking Changes - Available To Charges base on Mode of Payment Fixes' },
        ]
    },
    {
        version: 'V0.5.5.0',
        date: '25 Apr 2022',
        updateList: [
            { desc: 'CCM - remove duplicate Transship' },
        ]
    },
    {
        version: 'V0.5.4.9',
        date: '23 Apr 2022',
        updateList: [
            { desc: 'Manual SI - RAW MAT SVC PO Unrequire' },
        ]
    },
    {
        version: 'V0.5.4.8',
        date: '22 Apr 2022',
        updateList: [
            { desc: 'Manual SI - Additional Field SI Date Added' },
        ]
    },
    {
        version: 'V0.5.4.7',
        date: '21 Apr 2022',
        updateList: [
            { desc: 'Booking Changes Split Charge Fixes' },
        ]
    },
    {
        version: 'V0.5.4.6',
        date: '20 Apr 2022',
        updateList: [
            { desc: 'Booking Changes on Save checking of charges' },
        ]
    },
    {
        version: 'V0.5.4.5',
        date: '19 Apr 2022',
        updateList: [
            { desc: 'Booking Van-out Fee SQ and Master Data Checking' },
        ]
    },
    {
        version: 'V0.5.4.4',
        date: '18 Apr 2022',
        updateList: [
            { desc: 'Inbound Dwell Time Report Fixes' },
        ]
    },
    {
        version: 'V0.5.4.3B',
        date: '13 Apr 2022',
        updateList: [
            { desc: 'Cargo Costing Manifest - Separate CLR and Transship' },
            { desc: 'Create Collection Data Checking' },
        ]
    },
    {
        version: 'V0.5.4.3',
        date: '13 Apr 2022',
        updateList: [
            { desc: 'Cargo Costing Manifest Transship Via Fixes' },
            { desc: 'Remove Booking Changes - Accounting Approver Role' },
        ]
    },
    {
        version: 'V0.5.4.2',
        date: '12 Apr 2022',
        updateList: [
            { desc: 'Cargo Costing Manifest Fixes' },
            { desc: 'Door Address additional data selection feature' },
            { desc: 'Manual SI - add search SI and changes' },
        ]
    },
    {
        version: 'V0.5.4.2Z',
        date: '12 Apr 2022',
        updateList: [
            { desc: 'Cargo Costing Manifest Fixes' },
            { desc: 'Door Address additional data selection feature' },
        ]
    },
    {
        version: 'V0.5.4.1C',
        date: '11 Apr 2022',
        updateList: [
            { desc: 'Inbound Dwell Time Report Changes' },
        ]
    },
    {
        version: 'V0.5.4.1B',
        date: '11 Apr 2022',
        updateList: [
            { desc: 'Booking Changes Load Data Split Change Fixes' },
        ]
    },
    {
        version: 'V0.5.4.1',
        date: '11 Apr 2022',
        updateList: [
            { desc: 'Date Conversion Fixes for Mozilla Browser' },
        ]
    },
    {
        version: 'V0.5.4.0B',
        date: '08 Apr 2022',
        updateList: [
            { desc: 'OTGCI Inbound Tally Sheet Undo Role' },
            { desc: 'OTGCI Inbound Tally Sheet Finalize Changes' },
            { desc: 'Master Data Container Van Create Fixes' },
        ]
    },
    {
        version: 'V0.5.4.0',
        date: '08 Apr 2022',
        updateList: [
            { desc: 'CRO Accounting - Manual SI Fixes' },
        ]
    },
    {
        version: 'V0.5.3.9',
        date: '07 Apr 2022',
        updateList: [
            { desc: 'Booking Changes - Demurrage and Storage Fee Charge' },
            { desc: 'CRO Accounting - Manual SI Setup Feature' },
            { desc: 'OTGCI Tally Sheet Undo Role' },
            { desc: 'OTGCI Tally Sheet Finalize Changes' },
        ]
    },
    {
        version: 'V0.5.3.9Y',
        date: '07 Apr 2022',
        updateList: [
            { desc: 'Booking Changes - Demurrage and Storage Fee Charge' },
            { desc: 'Manual SI Changes' },
            { desc: 'OTGCI Tally Sheet Undo Role' },
            { desc: 'OTGCI Tally Sheet Finalize Changes' },
        ]
    },
    {
        version: 'V0.5.3.9Z',
        date: '07 Apr 2022',
        updateList: [
            { desc: 'CRO Accounting - Manual SI Setup Feature' },
        ]
    },
    {
        version: 'V0.5.3.8B',
        date: '06 Apr 2022',
        updateList: [
            { desc: 'Master Data - Trucking Rates Read Load Data Fixes' },
            { desc: 'Master Data - Port Rates Read Load Data Fixes' },
            { desc: 'Master Data - Freight Rates Read Load Data Fixes' },
        ]
    },
    {
        version: 'V0.5.3.8',
        date: '06 Apr 2022',
        updateList: [
            { desc: 'Master Data - Trucking Rates Update Load Data Fixes' },
            { desc: 'Master Data - Port Rates Update Load Data Fixes' },
        ]
    },
    {
        version: 'V0.5.3.7',
        date: '05 Apr 2022',
        updateList: [
            { desc: 'Waybill - Add Charge Fixes' },
        ]
    },
    {
        version: 'V0.5.3.6B',
        date: '04 Apr 2022',
        updateList: [
            { desc: 'Waybill - Add Charge Feature' },
            { desc: 'SQ Archive - Load Data Fixes' },
        ]
    },
    {
        version: 'V0.5.3.6',
        date: '04 Apr 2022',
        updateList: [
            { desc: 'Master Data Charge - Special Charge' },
            { desc: 'Master Data Customer - Charge Exemptions' },
            { desc: 'Sales Quotation Document Charges' },
            { desc: 'Booking - Special Charge' },
            { desc: 'Booking Changes - Special Charge' },
            { desc: 'Outbound Waybill - Exemption Charge' },
            { desc: 'SQ Aging Report - Allow all AE' },
            { desc: 'Waybill - Enable Demurrage and Storage Fee Charge To if Split' },
            { desc: 'Outbound Tally Sheet - Loading Data Fixes' },
            { desc: 'SQ Aging Report same as BASE' },
            { desc: 'SQ Report - SQ Updated List - Origin Area Fixes' },
            { desc: 'Casgo Costing Manifest Changes' },
            { desc: 'Actual Voyage Report Changes' },
        ]
    },
    {
        version: 'V0.5.3.5X',
        date: '29 Mar 2022',
        updateList: [
            { desc: 'Master Data Charge - Special Charge' },
            { desc: 'Master Data Customer - Charge Exemptions' },
            { desc: 'Sales Quotation Document Charges' },
            { desc: 'Booking - Special Charge' },
            { desc: 'Booking Changes - Special Charge' },
            { desc: 'Outbound Waybill - Exemption Charge' },
            { desc: 'SQ Aging Report - Allow all AE' },
        ]
    },
    {
        version: 'V0.5.3.5',
        date: '29 Mar 2022',
        updateList: [
            { desc: 'Booking Changes Create - Vanout Based on Mode of Delivery Fixes' },
        ]
    },
    {
        version: 'V0.5.3.4',
        date: '28 Mar 2022',
        updateList: [
            { desc: 'Booking Changes Read - Endorsed By Fixes' },
            { desc: 'Master Data Container Van Search Selected Fixes' },
        ]
    },
    {
        version: 'V0.5.3.3',
        date: '25 Mar 2022',
        updateList: [
            { desc: 'Waiver Read Add Booked By' },
            { desc: 'Waiver For Endorse - Endorse Button Show when Booked By User' },
            { desc: 'Waiver Draft List Fixes' },
            { desc: 'Waiver Create Draft Load Data Fixes' },
        ]
    },
    {
        version: 'V0.5.3.2B',
        date: '24 Mar 2022',
        updateList: [
            { desc: 'SQ Approval Print-out Previous and Proposed Fixes' },
            { desc: 'SQ Aging Report Fixes' },
            { desc: 'Booking Change Read Fixes' },
            { desc: 'CRO Accounting Posting Search Fixes' },
            { desc: 'Booking Changes Create - Stuffing Stripping Vanout Another Checking' },
        ]
    },
    {
        version: 'V0.5.3.2',
        date: '24 Mar 2022',
        updateList: [
            { desc: 'Waiver For Endorse List Fixes' },
        ]
    },
    {
        version: 'V0.5.3.1',
        date: '22 Mar 2022',
        updateList: [
            { desc: 'Master Data Port - remove Is Unique Rate' },
            { desc: 'System Account User Search Fixes' },
            { desc: 'Collection Read Fixes' },
        ]
    },
    {
        version: 'V0.5.3.0C',
        date: '21 Mar 2022',
        updateList: [
            { desc: 'Finalize Master Data Read/Edit Load Fixes' },
            { desc: 'System Account User Load Data Fixes' },
            { desc: 'Voyage Schedule Load Data Fixes' },
        ]
    },
    {
        version: 'V0.5.3.0B',
        date: '21 Mar 2022',
        updateList: [
            { desc: 'Collection Create Load Data Fixes' },
            { desc: 'Partial Master Data Read/Edit Load Fixes' },
        ]
    },
    {
        version: 'V0.5.3.0',
        date: '21 Mar 2022',
        updateList: [
            { desc: 'Booking Changes Approval Button Fixes' },
        ]
    },
    {
        version: 'V0.5.2.9',
        date: '19 Mar 2022',
        updateList: [
            { desc: 'System Account Role UI Changes for fast rendering' },
            { desc: 'List Search and Loading Data Fixes' },
        ]
    },
    {
        version: 'V0.5.2.8',
        date: '18 Mar 2022',
        updateList: [
            { desc: 'Actual Voyage Report Additional Data' },
        ]
    },
    {
        version: 'V0.5.2.7',
        date: '16 Mar 2022',
        updateList: [
            { desc: 'SQ Clear Data Upon Changing Page' },
        ]
    },
    {
        version: 'V0.5.2.6',
        date: '15 Mar 2022',
        updateList: [
            { desc: 'System Loading Fixes' },
        ]
    },
    {
        version: 'V0.5.2.5',
        date: '14 Mar 2022',
        updateList: [
            { desc: 'Booking CBS Print-out Additional Detail' },
            { desc: 'Outbound CTS Date change to Date and Time' },
        ]
    },
    {
        version: 'V0.5.2.4',
        date: '12 Mar 2022',
        updateList: [
            { desc: 'Voyage History Changes' },
            { desc: 'Cargo Release Order Create Outbound Demurrage' },
            { desc: 'SI Posting CY-In Changes' },
        ]
    },
    {
        version: 'V0.5.2.3',
        date: '08 Mar 2022',
        updateList: [
            { desc: 'Dwell Time Report Additional Columns' },
            { desc: 'CBS Additional Data' },
            { desc: 'Booking and Booking Changes Tandem Fixes' },
        ]
    },
    {
        version: 'V0.5.2.2B',
        date: '01 Mar 2022',
        updateList: [
            { desc: 'Cargo Arrival Notice Printout Not Count Day if Destination was not MNL' },
        ]
    },
    {
        version: 'V0.5.2.2',
        date: '01 Mar 2022',
        updateList: [
            { desc: 'Cargo Arrival Notice Printout Changes' },
        ]
    },
    {
        version: 'V0.5.2.1',
        date: '26 Feb 2022',
        updateList: [
            { desc: 'Booking Check Charge Saving' },
            { desc: 'Booking Changes Check Revise Charge Saving' },
            { desc: 'Mobile View Fixes - Booking Changes' },
            { desc: 'Mobile View Fixes - Override' },
            { desc: 'Mobile View Fixes - Sales Quotation' },
        ]
    },
    {
        version: 'V0.5.2.0',
        date: '25 Feb 2022',
        updateList: [
            { desc: 'Mobile View Fixes - Landing Page' },
            { desc: 'Mobile View Fixes - Master Data Company Policies' },
            { desc: 'Mobile View Fixes - Master Data Branch' },
            { desc: 'Mobile View Fixes - Master Data Container Yards' },
            { desc: 'Mobile View Fixes - Master Data Port' },
            { desc: 'Mobile View Fixes - Master Data Areas' },
            { desc: 'Mobile View Fixes - Master Data Cargo Type' },
            { desc: 'Mobile View Fixes - Master Data Service Mode' },
            { desc: 'Mobile View Fixes - Master Data Port Rate' },
            { desc: 'Mobile View Fixes - Master Data Trucking Rate' },
            { desc: 'Mobile View Fixes - Master Data Container Van' },
            { desc: 'Mobile View Fixes - Master Data Commodity Form' },
            { desc: 'Mobile View Fixes - Master Data Work Schedule' },
            { desc: 'Mobile View Fixes - Master Data Holidays' },
            { desc: 'Cargo Costing Manifest - add column Fuel Surcharge' },
            { desc: 'SI Archive excel - add column Fuel Surcharge' },
            { desc: 'Vessel Arrival Notice Printout Changes' },
            { desc: 'Cargo Arrival Notice Printout Changes' },
            { desc: 'SQ T&C Requested Changes' },
            { desc: 'Mobile View Fixes - Master Data Vessels' },
            { desc: 'Mobile View Fixes - Master Data Vessel Stowage Template' },
            { desc: 'Mobile View Fixes - Voyage Van History' },
            { desc: 'Mobile View Fixes - Outbound Waybill' },
            { desc: 'Mobile View Fixes - Outbound Tally Sheet' },
            { desc: 'Mobile View Fixes - Inbound Tally Sheet' },
            { desc: 'Mobile View Fixes - Inbound Cargo Release Order' },
            { desc: 'Mobile View Fixes - Inbound Van-In' },
            { desc: 'ATW Update from Releasing Type to Release Type' },
            { desc: 'Cargo Release Order Update name from Releasing Type to Release Type' },
        ]
    },
    {
        version: 'V0.5.1.9B',
        date: '24 Feb 2022',
        updateList: [
            { desc: 'Inbound Van-In Fixes' },
        ]
    },
    {
        version: 'V0.5.1.9',
        date: '24 Feb 2022',
        updateList: [
            { desc: 'Booking Fixes' },
        ]
    },
    {
        version: 'V0.5.1.8',
        date: '23 Feb 2022',
        updateList: [
            { desc: 'Booking Van-Out Charge Fixes' },
            { desc: 'Booking Changes Van-Out Fixes' },
        ]
    },
    {
        version: 'V0.5.1.7',
        date: '22 Feb 2022',
        updateList: [
            { desc: 'Booking Changes Stuffing, Stripping, Van-Out Fixes' },
        ]
    },
    {
        version: 'V0.5.1.6',
        date: '21 Feb 2022',
        updateList: [
            { desc: 'Booking Changes Fixes' },
            { desc: 'Dashboard Mobile View Fixes' },
        ]
    },
    {
        version: 'V0.5.1.5',
        date: '19 Feb 2022',
        updateList: [
            { desc: 'Outbound Loadlist - Upon Delete Check/Load Data' },
        ]
    },
    {
        version: 'V0.5.1.4C',
        date: '18 Feb 2022',
        updateList: [
            { desc: 'Inbound Van-In Demmurage Fixes' },
        ]
    },
    {
        version: 'V0.5.1.4B',
        date: '18 Feb 2022',
        updateList: [
            { desc: 'Inbound Van-In Demmurage Fixes' },
        ]
    },
    {
        version: 'V0.5.1.4',
        date: '18 Feb 2022',
        updateList: [
            { desc: 'Inbound Van-In Demmurage Fixes' },
        ]
    },
    {
        version: 'V0.5.1.3',
        date: '11 Feb 2022',
        updateList: [
            { desc: 'Booking and Booking Changes Van-Out Stuffing Stripping Fixes' },
            { desc: 'Booking and Booking Changes CY Stuffing (Mano) Charge' },
        ]
    },
    {
        version: 'V0.5.1.2',
        date: '10 Feb 2022',
        updateList: [
            { desc: 'CRO Accounting Posting Update Remove Duplicate Charges' },
        ]
    },
    {
        version: 'V0.5.1.1',
        date: '09 Feb 2022',
        updateList: [
            { desc: 'Profile Menu Fixes' },
            { desc: 'Master Data UI Fixes' },
            { desc: 'SQ Draft List UI Fixes' },
            { desc: 'Outbound UI Fixes' },
            { desc: 'Hustling UI Fixes' },
            { desc: 'Inbound Vessel Arrival Notice - View Unpaid Waybill Changes' },
        ]
    },
    {
        version: 'V0.5.1.0C',
        date: '07 Feb 2022',
        updateList: [
            { desc: 'Booking Changes Read Booked By' },
            { desc: 'Inbound Cargo Arrival Notice Send Email to Consignee' },
        ]
    },
    {
        version: 'V0.5.1.0B',
        date: '07 Feb 2022',
        updateList: [
            { desc: 'Booking Changes Stripping Stuffing Fixes' },
        ]
    },
    {
        version: 'V0.5.1.0',
        date: '07 Feb 2022',
        updateList: [
            { desc: 'Booking Changes Van Out Fixes' },
        ]
    },
    {
        version: 'V0.5.0.9',
        date: '05 Feb 2022',
        updateList: [
            { desc: 'Booking Van Out Origin and Destination' },
            { desc: 'Booking Changes Van Out Origin and Destination' },
            { desc: 'Cargo Loading Report and Cargo Costing Manifest Van Out Changes' },
        ]
    },
    {
        version: 'V0.5.0.8',
        date: '03 Feb 2022',
        updateList: [
            { desc: 'Booking Volume & CSR Report - Add No Data Found' },
            { desc: 'Booking Changes Read Fixes' },
            { desc: 'SQ Printout Fixes' },
        ]
    },
    {
        version: 'V0.5.0.7',
        date: '29 Jan 2022',
        updateList: [
            { desc: 'Inbound Vessel Arrival Notice View Unpaid Waybill Fixes' },
        ]
    },
    {
        version: 'V0.5.0.6',
        date: '27 Jan 2022',
        updateList: [
            { desc: 'SQ Fixes' },
            { desc: 'Inbound Dwell Time Report Fixes' },
        ]
    },
    {
        version: 'V0.5.0.5',
        date: '26 Jan 2022',
        updateList: [
            { desc: 'SQ Printout TC Terms of Payment Changes' },
        ]
    },
    {
        version: 'V0.5.0.4',
        date: '20 Jan 2022',
        updateList: [
            { desc: 'Booking Read Expire/Unexpire' },
            { desc: 'Dwell Time Report for Inbound Only' },
        ]
    },
    {
        version: 'V0.5.0.3',
        date: '19 Jan 2022',
        updateList: [
            { desc: 'SQ Printout Total Fixes' },
        ]
    },
    {
        version: 'V0.5.0.2B',
        date: '13 Jan 2022',
        updateList: [
            { desc: 'SQ Memo Charges Saves Include Particulars' },
            { desc: 'SI Archive Excel Additional Data' },
        ]
    },
    {
        version: 'V0.5.0.2',
        date: '13 Jan 2022',
        updateList: [
            { desc: 'SQ Printout Van Out Charge Fixes' },
        ]
    },
    {
        version: 'V0.5.0.1',
        date: '06 Jan 2022',
        updateList: [
            { desc: 'Print-out added Voyage Reference on Voyage Module - Van History' },
            { desc: 'Print-out added Voyage Reference on Voyage Module - Dwell Time Report' },
            { desc: 'Print-out added Voyage Reference on Voyage Module - Actual Voyage Report' },
            { desc: 'Print-out added Voyage Reference on Voyage Module - Voyage History Report' },
            { desc: 'Print-out added Voyage Reference on Outbound - CTS & CBS and CTS Report - Operation and Accounting' },
            { desc: 'Print-out added Voyage Reference on Outbound - Waybill and Truckers Waybill' },
            { desc: 'Print-out added Voyage Reference on Outbound - Tally Sheet' },
            { desc: 'Print-out added Voyage Reference on Outbound - On Tally Sheet (w/ Loading Report Excel)' },
            { desc: 'Print-out added Voyage Reference on Outbound - Stowage Plan' },
            { desc: 'Print-out added Voyage Reference on Inbound - Vessel Arrival Notice' },
            { desc: 'Print-out added Voyage Reference on Inbound - Tally Sheet' },
            { desc: 'Print-out added Voyage Reference on Inbound - Cargo Arrival Notice' },
            { desc: 'Print-out added Voyage Reference on Inbound - CTS & CDR' },
            { desc: 'Print-out added Voyage Reference on Hustling' },
        ]
    },
    {
        version: 'V0.5.0.0',
        date: '05 Jan 2022',
        updateList: [
            { desc: 'SQ Printout Total Charge Fixes' },
            { desc: 'Waiver For Endorsed Fixes' },
        ]
    },
    {
        version: 'V0.4.9.9',
        date: '15 Dec 2021',
        updateList: [
            { desc: 'SQ Printout Term # 5 Changes' },
        ]
    },
    {
        version: 'V0.4.9.8',
        date: '14 Dec 2021',
        updateList: [
            { desc: 'SQ Memorandum Save Fixes' },
        ]
    },
    {
        version: 'V0.4.9.7',
        date: '13 Dec 2021',
        updateList: [
            { desc: 'Company Policies Constants: Added VAN-OUT FEE IN PESO' },
            { desc: 'SQ Printout Term # 5 Changes' },
        ]
    },
    {
        version: 'V0.4.9.6',
        date: '11 Dec 2021',
        updateList: [
            { desc: 'MD UI Fixes' },
            { desc: 'SQ Creation UI Fixes' },
            { desc: 'Updated SQ List Additional Data - CY Stuffing Area, CY Stuffing Mano, Free Storage Days' },
        ]
    },
    {
        version: 'V0.4.9.5',
        date: '10 Dec 2021',
        updateList: [
            { desc: 'SQ Printout Term # 5 Changes' },
        ]
    },
    {
        version: 'V0.4.9.4',
        date: '09 Dec 2021',
        updateList: [
            { desc: 'Inbound UI Fixes' },
            { desc: 'Booking Changes UI Fixes' },
            { desc: 'Waiver UI Fixes' },
            { desc: 'CRO Accounting UI Fixes' },
            { desc: 'Override UI Fixes' },
            { desc: 'Hustling UI Fixes' },
            { desc: 'Customer Request UI Fixes' },
        ]
    },
    {
        version: 'V0.4.9.3',
        date: '08 Dec 2021',
        updateList: [
            { desc: 'Master Data UI Fixes' },
            { desc: 'Sales Quotaion UI Fixes' },
            { desc: 'Voyage UI Fixes' },
            { desc: 'Outbound UI Fixes' },
        ]
    },
    {
        version: 'V0.4.9.2',
        date: '07 Dec 2021',
        updateList: [
            { desc: 'Menu List UI Fixes' },
            { desc: 'Profile Setting UI Fixes' },
            { desc: 'PDF Printouts UI Fixes' },
            { desc: 'System Account - User UI Fixes' },
            { desc: 'System Account - Role UI Fixes' },
            { desc: 'Master Data - Customer UI Fixes' },
            { desc: 'Master Data - Company Policies UI Fixes' },
            { desc: 'Master Data - Branches UI Fixes' },
            { desc: 'Master Data - Container Yards UI Fixes' },
            { desc: 'Master Data - Ports  UI Fixes' },
            { desc: 'Master Data - Areas UI Fixes' },
            { desc: 'Master Data - Cargo TypesUI Fixes' },
            { desc: 'Master Data - Service Modes UI Fixes' },
            { desc: 'Master Data - Charges UI Fixes' },
        ]
    },
    {
        version: 'V0.4.9.1',
        date: '06 Dec 2021',
        updateList: [
            { desc: 'Outbound Waybill: Show Outbound Demurrage, Inbound Demurrage, Storage Fee Charge' },
        ]
    },
    {
        version: 'V0.4.9.0B',
        date: '27 Nov 2021',
        updateList: [
            { desc: 'Booking Change Create/Edit - Origin Branch is not equal to User Branch and Booking Status is At Vessel Loaded, only Is Via allow other are disable' },
        ]
    },
    {
        version: 'V0.4.9.0',
        date: '27 Nov 2021',
        updateList: [
            { desc: 'Booking Changes Approval Setup' },
            { desc: 'Booking Change Create/Edit - Original Destination is not equal to User Branch and Booking Status is At Vessel Loaded, only Is Via allow other are disable' },
        ]
    },
    {
        version: 'V0.4.8.9B',
        date: '22 Nov 2021',
        updateList: [
            { desc: 'BC Save' },
        ]
    },
    {
        version: 'V0.4.8.9',
        date: '22 Nov 2021',
        updateList: [
            { desc: 'Booking Change Create/Edit - Original Destination is not equal to User Branch and Booking Status is At Vessel Loaded, only Is Via allow other are disable' },
        ]
    },
    {
        version: 'V0.4.8.8',
        date: '20 Nov 2021',
        updateList: [
            { desc: 'SQ Printout For BB Per Ton Changes' },
        ]
    },
    {
        version: 'V0.4.8.7',
        date: '19 Nov 2021',
        updateList: [
            { desc: 'Booking Charge Loading Fixes' },
            { desc: 'CRO Accounting Collection Read Fixes' },
        ]
    },
    {
        version: 'V0.4.8.6B',
        date: '16 Nov 2021',
        updateList: [
            { desc: 'Booking Changes Read Charge INS Fixes' },
            { desc: 'Master Data Work Schedule: Allow Pullout On Holidays Fixes' },
        ]
    },
    {
        version: 'V0.4.8.6',
        date: '16 Nov 2021',
        updateList: [
            { desc: 'Booking Shipper Container Own, Require Container Field' },
            { desc: 'Booking Changes Shipper Container Own, Require Container Field' },
            { desc: 'Master Data Work Schedule: Allow Pullout On Holidays Field Added' },
        ]
    },
    {
        version: 'V0.4.8.5',
        date: '13 Nov 2021',
        updateList: [
            { desc: 'Booking Require Text Check and Fixes' },
            { desc: 'Booking Changes Require Text Check and Fixes' },
        ]
    },
    {
        version: 'V0.4.8.4',
        date: '11 Nov 2021',
        updateList: [
            { desc: 'SQ Printout Charge Particular Nextline' },
        ]
    },
    {
        version: 'V0.4.8.3B',
        date: '10 Nov 2021',
        updateList: [
            { desc: 'SQ Printout Terms & Condition no. 9. Change the word after to within' },
        ]
    },
    {
        version: 'V0.4.8.3',
        date: '10 Nov 2021',
        updateList: [
            { desc: 'Outbound Waybill Read Fixes' },
        ]
    },
    {
        version: 'V0.4.8.2',
        date: '09 Nov 2021',
        updateList: [
            { desc: 'Outbound Waybill: Outbound Demmurage, Inbound Demmurage, Storage Fee Amount Set' },
        ]
    },
    {
        version: 'V0.4.8.1',
        date: '03 Nov 2021',
        updateList: [
            { desc: 'Booking Before Saving Check Booking Charges' },
            { desc: 'Vessel History Report Full and Empty' },
            { desc: 'Master Data Holiday Category Changes' },
            { desc: 'Master Data Company Policies Edit Render Data Fixes' },
        ]
    },
    {
        version: 'V0.4.8.0',
        date: '29 Oct 2021',
        updateList: [
            { desc: 'Customer Request Customer Detail Required' },
            { desc: 'Booking: Charge Change Charge To Fixes' },
            { desc: 'Booking Edit and Read: Is Split Charge Fixes' },
        ]
    },
    {
        version: 'V0.4.7.9',
        date: '25 Oct 2021',
        updateList: [
            { desc: 'Master Data Customer: Email Required' },
            { desc: 'Cargo Costing Manifest: Pick-up Address, Delivery Address, Amend' },
            { desc: 'Booking Search: Transaction Date to Booking Date' },
            { desc: 'Voyage History Report: Movement Added' },
        ]
    },
    {
        version: 'V0.4.7.8',
        date: '22 Oct 2021',
        updateList: [
            { desc: 'SQ Printout Noted By Fixes' },
        ]
    },
    {
        version: 'V0.4.7.7',
        date: '21 Oct 2021',
        updateList: [
            { desc: 'SQ Approved Viewer Amend Sorting' },
        ]
    },
    {
        version: 'V0.4.7.6',
        date: '20 Oct 2021',
        updateList: [
            { desc: 'Booking Charge Fixes' },
            { desc: 'SQ List Search Customer Name Default' },
        ]
    },
    {
        version: 'V0.4.7.5',
        date: '20 Oct 2021',
        updateList: [
            { desc: 'SQ Printout Stripping Stuffing Charge Duplicate' },
        ]
    },
    {
        version: 'V0.4.7.4',
        date: '14 Oct 2021',
        updateList: [
            { desc: 'Booking Search Fixes' },
        ]
    },
    {
        version: 'V0.4.7.3',
        date: '13 Oct 2021',
        updateList: [
            { desc: 'Booking Search UI Changes and Transaction Date Latest to Oldest Sorting Order' },
        ]
    },
    {
        version: 'V0.4.7.2',
        date: '09 Oct 2021',
        updateList: [
            { desc: 'SQ Memorandum Changes Live' },
        ]
    },
    {
        version: 'V0.4.7.1',
        date: '08 Oct 2021',
        updateList: [
            { desc: 'SQ Memorandum Changes' },
        ]
    },
    {
        version: 'V0.4.7.0',
        date: '05 Oct 2021',
        updateList: [
            { desc: 'Master Data Freight Rate Create - Auto Fill depends on Previous Page Create Button Selected' },
            { desc: 'Master Data Port Rate Create - Auto Fill depends on Previous Page Create Button Selected' },
            { desc: 'Master Data Trucking Rate Create - Auto Fill depends on Previous Page Create Button Selected' },
            { desc: 'Outbound ATW Additional Data' },
        ]
    },
    {
        version: 'V0.4.6.9',
        date: '28 Sep 2021',
        updateList: [
            { desc: 'Booking Split Check Charge To' },
            { desc: 'Customer and Customer Request: Files Changes' },
            { desc: 'Version Requirement Feature' },
        ]
    },
    {
        version: 'V0.4.6.8',
        date: '27 Sep 2021',
        updateList: [
            { desc: 'CBS Consignee Pickup Address Printout to Delivery Address' },
        ]
    },
    {
        version: 'V0.4.6.7',
        date: '24 Sep 2021',
        updateList: [
            { desc: 'SQ Printout: No Area Charge Duplicate Remove' },
        ]
    },
    {
        version: 'V0.4.6.6B',
        date: '23 Sep 2021',
        updateList: [
            { desc: 'Voyage: Booking Volume & CSR Report New Format' },
            { desc: 'Collection: Create Fixes' },
            { desc: 'Outbound CTS: Edit Remove Status Condition' },
        ]
    },
    {
        version: 'V0.4.6.6',
        date: '23 Sep 2021',
        updateList: [
            { desc: 'Booking Rollback Save' },
        ]
    },
    {
        version: 'V0.4.6.5',
        date: '22 Sep 2021',
        updateList: [
            { desc: 'Booking and Booking Changes Validation: check pickup and delivery address for empty space' },
        ]
    },
    {
        version: 'V0.4.6.4',
        date: '21 Sep 2021',
        updateList: [
            { desc: 'Remove Old Booking Reference and Old Waybill Reference on System' },
            { desc: 'Inbound Van-In: Check Tandem Type Fixes' },
        ]
    },
    {
        version: 'V0.4.6.3C',
        date: '18 Sep 2021',
        updateList: [
            { desc: 'Role: CSR Report - Is CSR Added' },
        ]
    },
    {
        version: 'V0.4.6.3B',
        date: '18 Sep 2021',
        updateList: [
            { desc: 'Vessel Arrival Notice: ATA leave blank Printout' },
            { desc: 'Vessel Arrival Notice: ATA leave blank Excel' },
            { desc: 'Booking Volume & CSR Report Changes' },
        ]
    },
    {
        version: 'V0.4.6.3',
        date: '18 Sep 2021',
        updateList: [
            { desc: 'Booking Changes: Amend Fee Fixes' },
        ]
    },
    {
        version: 'V0.4.6.2',
        date: '17 Sep 2021',
        updateList: [
            { desc: 'Waybill Printout Commodity Split Word' },
        ]
    },
    {
        version: 'V0.4.6.1B',
        date: '16 Sep 2021',
        updateList: [
            { desc: 'Booking: Charge Fixes' },
            { desc: 'Booking Changes: Charge Fixes' },
        ]
    },
    {
        version: 'V0.4.6.1',
        date: '16 Sep 2021',
        updateList: [
            { desc: 'SQ Printout RC BB Fixes' },
        ]
    },
    {
        version: 'V0.4.6.0',
        date: '14 Sep 2021',
        updateList: [
            { desc: 'SQ Aging Report Changes' },
        ]
    },
    {
        version: 'V0.4.5.9',
        date: '13 Sep 2021',
        updateList: [
            { desc: 'Booking: Old Booking Ref not required' },
            { desc: 'Waybill: Old Waybill Ref not required' },
        ]
    },
    {
        version: 'V0.4.5.8',
        date: '11 Sep 2021',
        updateList: [
            { desc: 'SQ Printout Total Fixes' },
        ]
    },
    {
        version: 'V0.4.5.7B',
        date: '07 Sep 2021',
        updateList: [
            { desc: 'SQ Printout Total Fixes' },
        ]
    },
    {
        version: 'V0.4.5.7',
        date: '07 Sep 2021',
        updateList: [
            { desc: 'MD Trucking Search Fixes' },
            { desc: 'SQ Printout Total Fixes' },
        ]
    },
    {
        version: 'V0.4.5.6',
        date: '06 Sep 2021',
        updateList: [
            { desc: 'Waiver: For Endorse Sub Module Added' },
            { desc: 'Role: Wauver For Endorse Added' },
            { desc: 'Waiver List: Draft - Submit For Endorsement and Endorse Button Added' },
            { desc: 'Waiver List: For Endorse - Endorse and Deny Button Added' },
            { desc: 'Waiver List: For Approval - Approve and Deny Button Added' },
        ]
    },
    {
        version: 'V0.4.5.5',
        date: '04 Sep 2021',
        updateList: [
            { desc: 'Booking Changes List: Field to Amended and Requested Column additional detail - Stuffing, Stripping, Shipper Own, Tandem, Dangerous Cargo, Open Van Added' },
        ]
    },
    {
        version: 'V0.4.5.4',
        date: '03 Sep 2021',
        updateList: [
            { desc: 'Booking Changes List: Select All Fixes' },
            { desc: 'Master Data Customer: Assign AE Added' },
            { desc: 'Customer Request: Assign AE Added' },
        ]
    },
    {
        version: 'V0.4.5.3',
        date: '01 Sep 2021',
        updateList: [
            { desc: 'Booking Create Split Include Collect and Account Destination Check Fixes' },
        ]
    },
    {
        version: 'V0.4.5.2',
        date: '31 Aug 2021',
        updateList: [
            { desc: 'Inbound Cargo Arrival Notice PDF Fixes' },
            { desc: 'Booking Create: Split Fixes' },
        ]
    },
    {
        version: 'V0.4.5.1',
        date: '26 Aug 2021',
        updateList: [
            { desc: 'Aging Report UI Changes' },
        ]
    },
    {
        version: 'V0.4.5.0',
        date: '25 Aug 2021',
        updateList: [
            { desc: 'Outbound Waybill Read Charge Fixes' },
        ]
    },
    {
        version: 'V0.4.4.9',
        date: '24 Aug 2021',
        updateList: [
            { desc: 'Role: SQ Aging Report Added' },
            { desc: 'SQ Aging Report Module Added' },
            { desc: 'Collection: Additional Form of Payment' },
        ]
    },
    {
        version: 'V0.4.4.8',
        date: '23 Aug 2021',
        updateList: [
            { desc: 'SQ Printout Fixes' },
        ]
    },
    {
        version: 'V0.4.4.7',
        date: '20 Aug 2021',
        updateList: [
            { desc: 'Outbound and Inbound Tally Sheet Form Overflow Changes' },
            { desc: 'Booking Changes List: Remove Posted Condition' },
        ]
    },
    {
        version: 'V0.4.4.6B',
        date: '18 Aug 2021',
        updateList: [
            { desc: 'Booking Changes Rollback Accounting Approver with SI Posted' },
        ]
    },
    {
        version: 'V0.4.4.6',
        date: '18 Aug 2021',
        updateList: [
            { desc: 'Booking Changes List: Requested Shipper Pickup Address and Consignee Delivery Address null remove' },
        ]
    },
    {
        version: 'V0.4.4.5',
        date: '17 Aug 2021',
        updateList: [
            { desc: 'Inbound Vessel Arrival Notice Printout Added MOD and MOP' },
            { desc: 'Inbound Cargo Arrival Notice Printout Added MOD and MOP and same sa Vessel Arrival Notice for multiple on same Shipper and Consignee' },
            { desc: 'Voyage Dwell Time Report UI Changes' },
        ]
    },
    {
        version: 'V0.4.4.4',
        date: '16 Aug 2021',
        updateList: [
            { desc: 'SQ Printout Fixes' },
            { desc: 'Master Data: Trucking Rate with Province' },
            { desc: 'Vessel Arrival Notice Printout ETD to ATA' },
            { desc: 'Booking Changes List: Shipper Pickup Address and Consignee Delivery Address null remove' },
        ]
    },
    {
        version: 'V0.4.4.3',
        date: '13 Aug 2021',
        updateList: [
            { desc: 'Booking Read: Origin and Destination Area add Province' },
            { desc: 'SQ RC and BB Printout Changes' },
            { desc: 'Booking Changes: List Multiple Submit/Approve/Endorse' },
            { desc: 'Booking Changes: Split Charge Fixes' },
        ]
    },
    {
        version: 'V0.4.4.2',
        date: '11 Aug 2021',
        updateList: [
            { desc: 'Booking Read: remove Is Lift On/Lift Off' },
        ]
    },
    {
        version: 'V0.4.4.1',
        date: '10 Aug 2021',
        updateList: [
            { desc: 'Update Logo to higher quality' },
        ]
    },
    {
        version: 'V0.4.4.0',
        date: '09 Aug 2021',
        updateList: [
            { desc: 'Sounding Report Fixes' },
        ]
    },
    {
        version: 'V0.4.3.9B',
        date: '05 Aug 2021',
        updateList: [
            { desc: 'Booking Changes Read: Pickup Address remove null character' },
        ]
    },
    {
        version: 'V0.4.3.9',
        date: '05 Aug 2021',
        updateList: [
            { desc: 'Outbound Waybill Total Charges Computation Fixes' },
        ]
    },
    {
        version: 'V0.4.3.8',
        date: '04 Aug 2021',
        updateList: [
            { desc: 'Booking Read: Stuffing and Stripping Type Added' },
            { desc: 'SQ Terms and Conditions' },
        ]
    },
    {
        version: 'V0.4.3.7',
        date: '03 Aug 2021',
        updateList: [
            { desc: 'Booking Changes Remove IsNewlyAdded find Function' },
        ]
    },
    {
        version: 'V0.4.3.6B',
        date: '30 Jul 2021',
        updateList: [
            { desc: 'Booking and Booking Changes = City and Municipality into City/Municipality' },
        ]
    },
    {
        version: 'V0.4.3.6',
        date: '30 Jul 2021',
        updateList: [
            { desc: 'Booking Changes RC BB Charge Fixes' },
        ]
    },
    {
        version: 'V0.4.3.5B',
        date: '29 Jul 2021',
        updateList: [
            { desc: 'Booking and Booking Changes = Split Pick-up/Delivery Address into separate parts such as Street, Barangay, City, Municipality, Province, Zip Code' },
            { desc: 'SQ Memorandum Document Changes' },
        ]
    },
    {
        version: 'V0.4.3.5',
        date: '29 Jul 2021',
        updateList: [
            { desc: 'Booking Changes - Door Transaction Change Destination required Area and Delivery Address' },
            { desc: 'SQ Memorandum Enable Save' },
        ]
    },
    {
        version: 'V0.4.3.4',
        date: '26 Jul 2021',
        updateList: [
            { desc: 'SQ Printout Charge Set to 2 Decimal Place' },
            { desc: 'SQ Memorandum UI Changes' },
        ]
    },
    {
        version: 'V0.4.3.3',
        date: '24 Jul 2021',
        updateList: [
            { desc: 'Minor Changes' },
            { desc: 'Sounding Report Fixes' },
        ]
    },
    {
        version: 'V0.4.3.2',
        date: '23 Jul 2021',
        updateList: [
            { desc: 'Waiver: Charge Filter change' },
            { desc: 'Sounding Report Update: Add Departure Date and Arrival Date' },
            { desc: 'Sounding Report Changes' },
            { desc: 'CRO Accounting Posting List Changes' },
            { desc: 'SQ (LCT) VOYAGE CHARTER' },
            { desc: 'SQ Approved Viewer Route Sorting' },
        ]
    },
    {
        version: 'V0.4.3.1',
        date: '21 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: Remove Set Date Effective for Amendment Fee' },
            { desc: 'Booking Changes: Attach File that are not Image, allow download' },
            { desc: 'SQ Document Creation: Branch Port Fixes' },
        ]
    },
    {
        version: 'V0.4.3.0',
        date: '19 Jul 2021',
        updateList: [
            { desc: 'Sounding Report Per Vessel Download Fixes' },
            { desc: 'Sounding Report Voyage Table add Total and on Download' },
        ]
    },
    {
        version: 'V0.4.2.9B',
        date: '17 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: Set Date Effective for Amendment Fee Fixes' },
        ]
    },
    {
        version: 'V0.4.2.9',
        date: '17 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: Set Date Effective for Amendment Fee' },
        ]
    },
    {
        version: 'V0.4.2.8B',
        date: '16 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: Amendment Fee' },
        ]
    },
    {
        version: 'V0.4.2.8',
        date: '16 Jul 2021',
        updateList: [
            { desc: 'Inbound Tallysheet Fixes' },
        ]
    },
    {
        version: 'V0.4.2.7',
        date: '10 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: Save Fixes' },
        ]
    },
    {
        version: 'V0.4.2.6',
        date: '09 Jul 2021',
        updateList: [
            { desc: 'Booking and Booking Changes: Tandem Fixes' },
        ]
    },
    {
        version: 'V0.4.2.5B',
        date: '08 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: Amendment Fee Fixes' },
        ]
    },
    {
        version: 'V0.4.2.5',
        date: '08 Jul 2021',
        updateList: [
            { desc: 'Voyage Sounding Report Fixes' },
        ]
    },
    {
        version: 'V0.4.2.4',
        date: '07 Jul 2021',
        updateList: [
            { desc: 'Booking Changes: New Amendment Fee Setup' },
            { desc: 'Voyage Sounding Report Fixes' },
        ]
    },
    {
        version: 'V0.4.2.3B',
        date: '07 Jul 2021',
        updateList: [
            { desc: 'Booking Change Creation Fixes' },
            { desc: 'Inbound CTS Update Fixes' },
        ]
    },
    {
        version: 'V0.4.2.3',
        date: '07 Jul 2021',
        updateList: [
            { desc: 'Booking Change Creation Fixes' },
        ]
    },
    {
        version: 'V0.4.2.2',
        date: '06 Jul 2021',
        updateList: [
            { desc: 'Booking Change Get Goods Category' },
            { desc: 'Voyage Sounding Report New Layout' },
        ]
    },
    {
        version: 'V0.4.2.1',
        date: '03 Jul 2021',
        updateList: [
            { desc: 'Booking: Stuffing ang Stripping' },
            { desc: 'SQ Memorandum Changes' },
        ]
    },
    {
        version: 'V0.4.2.0',
        date: '30 Jun 2021',
        updateList: [
            { desc: 'Booking Changes Save Fixes' },
        ]
    },
    {
        version: 'V0.4.1.9',
        date: '29 Jun 2021',
        updateList: [
            { desc: 'SQ Memorandum Changes' },
            { desc: 'Move Unpaid Waybill from CRO Clearance to Vessel Arrival Notice' },
        ]
    },
    {
        version: 'V0.4.1.8',
        date: '28 Jun 2021',
        updateList: [
            { desc: 'SQ Memorandum Changes' },
        ]
    },
    {
        version: 'V0.4.1.7',
        date: '25 Jun 2021',
        updateList: [
            { desc: 'Booking Changes: Amendment Fee Rollback' },
        ]
    },
    {
        version: 'V0.4.1.6',
        date: '24 Jun 2021',
        updateList: [
            { desc: 'Voyage Schedule: Enable ATA' },
            { desc: 'Waybill Printout Fixes: Consignee Pickup Address to Delivery Address' },
        ]
    },
    {
        version: 'V0.4.1.5',
        date: '21 Jun 2021',
        updateList: [
            { desc: 'Booking Changes: Amendment Fee Setup' },
            { desc: 'Booking Changes Status: Management Approved Added' },
            { desc: 'Booking Changes: Charges Approved to BASE SI' },
        ]
    },
    {
        version: 'V0.4.1.4B',
        date: '21 Jun 2021',
        updateList: [
            { desc: 'SQ Creation: On Terms and Conditions Added Checkbox Allow Zero' },
            { desc: 'SQ Printout Terms and Conditions Allow Zero' },
        ]
    },
    {
        version: 'V0.4.1.4',
        date: '21 Jun 2021',
        updateList: [
            { desc: 'Master Data: Trucking Added Search by Branch' },
            { desc: 'Master Data: Trucking Added Download Trucker Excel' },
            { desc: 'Role Master Data: Trucking Download Added' },
            { desc: 'SQ Memorandum: UI Changes' },
        ]
    },
    {
        version: 'V0.4.1.3',
        date: '18 Jun 2021',
        updateList: [
            { desc: 'Waybill Generate Printout Fixes' },
        ]
    },
    {
        version: 'V0.4.1.2C',
        date: '17 Jun 2021',
        updateList: [
            { desc: 'Waybill Create Generate Printout Fixes' },
        ]
    },
    {
        version: 'V0.4.1.2B',
        date: '17 Jun 2021',
        updateList: [
            { desc: 'Waybill Create Generate Printout Fixes' },
            { desc: 'Booking Changes: Amendment Fee Setup' },
        ]
    },
    {
        version: 'V0.4.1.2',
        date: '17 Jun 2021',
        updateList: [
            { desc: 'Booking Changes Status: Management Approved Added' },
            { desc: 'Booking Changes: Charges Approved to BASE SI' },
        ]
    },
    {
        version: 'V0.4.1.1C',
        date: '16 Jun 2021',
        updateList: [
            { desc: 'Voyage Schedule: ATD Format to Date and Time' },
            { desc: 'Hustling: Remarks Added' },
        ]
    },
    {
        version: 'V0.4.1.1B',
        date: '16 Jun 2021',
        updateList: [
            { desc: 'SQ Memorandum Summary Fixes' },
        ]
    },
    {
        version: 'V0.4.1.1',
        date: '16 Jun 2021',
        updateList: [
            { desc: 'SQ Printout: Total Charge Fixes' },
            { desc: 'SQ Memorandum Module Setup' },
            { desc: 'Voyage Schedule: Enable ATD'}
        ]
    },
    {
        version: 'V0.4.1.0B',
        date: '11 Jun 2021',
        updateList: [
            { desc: 'Booking: Print CBS Fixes' },
        ]
    },
    {
        version: 'V0.4.1.0',
        date: '11 Jun 2021',
        updateList: [
            { desc: 'Waybill added Waybill Trucker Printout only on Backload' },
            { desc: 'User Branch Add Button change placement' },
        ]
    },
    {
        version: 'V0.4.0.9C',
        date: '07 Jun 2021',
        updateList: [
            { desc: 'Revenue Report: Voyage Number Fixes' },
        ]
    },
    {
        version: 'V0.4.0.9B',
        date: '07 Jun 2021',
        updateList: [
            { desc: 'Booking Changes: Callback on Submit' },
        ]
    },
    {
        version: 'V0.4.0.9',
        date: '07 Jun 2021',
        updateList: [
            { desc: 'Cargo Costing Manifest: SOC Charge Column Added'},
            { desc: 'Booking Changes Creation: Change service mode to Door Transaction require Pickup/Delivery Address' },
        ]
    },
    {
        version: 'V0.4.0.8',
        date: '05 Jun 2021',
        updateList: [
            { desc: 'Sounding Report: ATD and ATA Date Fixes'},
            { desc: 'Booking Changes Creation: Change service mode to Door Transaction require Pickup/Delivery Address' },
        ]
    },
    {
        version: 'V0.4.0.7',
        date: '04 Jun 2021',
        updateList: [
            { desc: 'Roles: Booking Changes - Accounting Approver Added' },
            { desc: 'Voyage Revenue Report: Fixes on Routes' },
        ]
    },
    {
        version: 'V0.4.0.6C',
        date: '01 Jun 2021',
        updateList: [
            { desc: 'AE Inbound Role Access Changes' },
        ]
    },
    {
        version: 'V0.4.0.6B',
        date: '01 Jun 2021',
        updateList: [
            { desc: 'Inbound CTS and CDR: Waybill Trucker fixes' },
        ]
    },
    {
        version: 'V0.4.0.6',
        date: '01 Jun 2021',
        updateList: [
            { desc: 'Voyage Schedule ATA: Disabled base on Condition and change to Date and Time Format' },
        ]
    },
    {
        version: 'V0.4.0.5',
        date: '29 May 2021',
        updateList: [
            { desc: 'Add Browser Data Storage for Trailer Number and Helper Name' },
            { desc: 'Sounding Report New Layout' },
            { desc: 'Booking Create: Remove Destination Default and Add Require' },
        ]
    },
    {
        version: 'V0.4.0.4B',
        date: '27 May 2021',
        updateList: [
            { desc: 'Trucker Waybill Printout added High Point Logo' },
            { desc: 'Voyage Sounding Report Different Sheet Per Vessel' },
        ]
    },
    {
        version: 'V0.4.0.4',
        date: '27 May 2021',
        updateList: [
            { desc: 'Voyage Sounding Report Module Added' },
            { desc: 'Role Sounding Report Added under Voyage' },
        ]
    },
    {
        version: 'V0.4.0.3B',
        date: '26 May 2021',
        updateList: [
            { desc: 'Outbound CTS and CBS List: Truckers Waybill Option added' },
            { desc: 'Outbound CTS and CBS List: Merge to CTS and CBS Printout' },
            { desc: 'Inbound CTS and CDR List: Merge to CTS and CDR Printout' },
            { desc: 'Outbound Waybill Read: New Charge Format' },
        ]
    },
    {
        version: 'V0.4.0.3',
        date: '26 May 2021',
        updateList: [
            { desc: 'Outbound CTS and CBS List: Truckers Waybill Printout added' },
            { desc: 'Inbound CTS and CDR List: Truckers Waybill Printout added' },
        ]
    },
    {
        version: 'V0.4.0.2B',
        date: '25 May 2021',
        updateList: [
            { desc: 'Inbound Dispatch Module: Additional Data' },
        ]
    },
    {
        version: 'V0.4.0.2',
        date: '25 May 2021',
        updateList: [
            { desc: 'Outbound ATW: Door Origin Transaction, Trailer No. and Helper Name Added' },
            { desc: 'Outbound CTS and CBS Create: Truckers Waybill Printout added' },
            { desc: 'Inbound CRO: Door Destination Transaction, Trailer No. and Helper Name Added' },
            { desc: 'Inbound CTS and CDR Create: Truckers Waybill Printout added' },
            { desc: 'Outbound and Inbound Dispatch Module: Archive Dispatch Module Added' },
            { desc: 'Cargo Costing Manifest: Separate with Origin and Destination' },
        ]
    },
    {
        version: 'V0.4.0.1',
        date: '21 May 2021',
        updateList: [
            { desc: 'Booking: Pick-up Date change to Date and Time' },
            { desc: 'Dispatch Module Update and Submit for Dispatch' },
            { desc: 'Booking Changes: mode of delivery fixes' },
        ]
    },
    {
        version: 'V0.4.0.0B',
        date: '20 May 2021',
        updateList: [
            { desc: 'Stowage Plan: remove Location Filter' },
            { desc: 'Dispatch Module other Setup' },
        ]
    },
    {
        version: 'V0.4.0.0',
        date: '20 May 2021',
        updateList: [
            { desc: 'Outbound CTS Create, get other booking data' },
            { desc: 'CRO Accounting SI Posting: SI List Excel Fixes' },
        ]
    },
];